
export const fixedImageName = 'fixed';
export const movingImageName = 'moving';
export const matchName = 'result';
export const compareName = 'compare';
export const stitchName = 'stitch';
export const multiStitchName = 'multiStitch';